import Model from '@ember-data/model';

// Booking channel reference data (id is the channel slug, e.g. `airbnb_official`).
// Mirrors the API's `channels` relationship on automated message rules.
export default class ChannelModel extends Model {}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    channel: ChannelModel;
  }
}
